/** @format */
import { Directive, ElementRef, EventEmitter, Injector, Input, Output } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
import { AddCourseUnitRealisationValues } from './addCourseUnitRealisationDialog.component';

/**
 * @deprecated
 */
@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'add-course-unit-realisation-dialog',
    standalone: false,
})
export class AddCourseUnitRealisationDialogDirective extends UpgradeComponent {
    @Output() close: EventEmitter<any>;
    @Output() dismiss: EventEmitter<any>;
    @Input() resolve: AddCourseUnitRealisationValues;

    constructor(elementRef: ElementRef<any>, injector: Injector) {
        super('addCourseUnitRealisationDialog', elementRef, injector);
    }
}
